import React, { useEffect, useState } from 'react';
import { GetListPatientForConferm } from '../adapters/GetListPatientForConferm';
import { useAtom } from 'jotai';
import { refetchAtom } from '../shared/refetch.shared.atom';
import useDebounce from 'Global/Hooks/useDebounce/useDebounce';

const useFetchLabPatientList = (filterData) => {
  const [listPatient, setListPatient] = useState([]);
  const [refetch] = useAtom(refetchAtom);

  const data = useDebounce(filterData);

  useEffect(() => {
    if (filterData.idPato.toString().length > 0) {
      GetListPatientForConferm(filterData, setListPatient);
    }
  }, [JSON.stringify(data), refetch]);

  return listPatient;
};

export default useFetchLabPatientList;
